import { combineReducers } from "redux";
import { SettingsReducer } from "./store/reducer";
export const reducer = combineReducers({
    settings: SettingsReducer
});
